// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function reason_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                id: id._0,
                name: name._0
              }
            };
    }
    var e = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var reasons_for_customers = Decco.listFromJson(reason_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "reasons_for_customers"), null));
  if (reasons_for_customers.TAG === /* Ok */0) {
    var reasons_for_drivers = Decco.listFromJson(reason_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "reasons_for_drivers"), null));
    if (reasons_for_drivers.TAG === /* Ok */0) {
      var reasons_for_allocation = Decco.listFromJson(reason_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "reasons_for_allocation"), null));
      if (reasons_for_allocation.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  reasons_for_customers: reasons_for_customers._0,
                  reasons_for_drivers: reasons_for_drivers._0,
                  reasons_for_allocation: reasons_for_allocation._0
                }
              };
      }
      var e = reasons_for_allocation._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".reasons_for_allocation" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = reasons_for_drivers._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".reasons_for_drivers" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = reasons_for_customers._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".reasons_for_customers" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

export {
  reason_decode ,
  t_decode ,
  
}
/* No side effect */
